<template>
  <div class="common-banner" v-if="bannerList?.length">
    <WphkBanner :class="['main-banner']" type="swiper" :bannerList="bannerList" :isMultBrow="false" />
  </div>
</template>

<script setup lang="ts">
import { ModuleName } from '@/types/module-type';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { onBeforeMount, ref } from 'vue';
import { useConfigStore } from '@/store';
const props = defineProps<{ moduleName: ModuleName }>();
const { getConfig } = useConfigStore();
// banner 列表
const bannerList = ref<BannerConfig[]>();
onBeforeMount(async () => {
  const { bannerList: bannerListVal = [] } = await getConfig(props.moduleName);
  bannerList.value = bannerListVal;
});
</script>

<style lang="less" scoped>
@import (reference) "~@/less/main.less";
/deep/ .banner-container {
  height: auto !important;
}

/deep/ .banner-image {
  width: 686 / @rem;
  height: 176 / @rem;
  border-radius: 16 / @rem;
  display: block;
  margin: auto;
}
</style>
